import React, { useContext, useEffect, useState, useRef } from "react";
import '../css/style.css';
import { useLocation } from "react-router-dom";
import HalloweenModal from "./halloweenModal";
import imageSrc from "../images/yacht_rock_band_dirty_yachtin_scoundrels_storm.webp";
import HeroScene from './HeroScene';
import './../css/ParallaxHero.css';
/*import dys from "../images/pngs/DYS-Logo-White-Backer.png";*/
import dys from "../images/pngs/DYS_Logo_horiz-orange.png";
/*import dys from "../images/pngs/DYS-Logo-horiz-white.png";*/
/*import dys from "../images/pngs/DYS-Logo-horiz.png";*/
/*import dys from "../images/pngs/dys-new-logo.png";*/
// Function to get the current page name from the URL
function CurrentPage() {
    const location = useLocation();
    return <div>{location.pathname.slice(1)}</div>;
}

// Converted MainImage to a function component
export function MainImage() {
    const [showModal, setShowModal] = useState(false);
    return (
        <div >{/*className = "image-wrapper"*/}
            {/* Uncomment to display the current route name */}
            {/* <span className="page-name"><CurrentPage /></span> */}
            {/*<button*/}
            {/*    onClick={() => setShowModal(true)}*/}
            {/*    className="scary_button"*/}
            {/*>*/}
            {/*    Click here to see something scary*/}
            {/*</button>*/}
            <div className="dys-text-wrap">
                <img
                    src={dys}
                    className="dys-text"
                    alt="Dirty Yachtin Scoundrels - Yacht Rock Band"
                />
            </div>
            <HeroScene className="hero-scene" />
            <img
                src={require("../images/mobile-band.webp")}
                className="hero-mobile-image"
                alt="Dirty Yachtin' Scoundrels - Arizona Yacht Rock Band"
            />
            
            {/*<HalloweenModal*/}
            {/*    show={showModal}*/}
            {/*    onClose={() => setShowModal(false)}*/}
            {/*    smallImageSrc={require("../images/small_preview_image.png")}*/}
            {/*    bigImageSrc={require("../images/exorcist.webp")}*/}
            {/*    soundSrc={require("../sounds/boathorn.mp3")}*/}
            {/*/>*/}
        </div>
    );
}
